<nz-card nzTitle="Timeline">
	<app-timeline [entries]="entries"></app-timeline>
</nz-card>